import React, { lazy, useEffect } from 'react';
import { Navigate, useLocation, useSearchParams } from 'react-router-dom';

const ActivityPage = lazy(() => import('./ActivityPage'));
const ComparisonPage = lazy(() => import('./ComparisonPage'));

export const ComparisonRoute: React.FC = () => {
  const [params] = useSearchParams();
  const isSaved = params.get('tab') === 'saved';
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' as ScrollBehavior });
  }, [isSaved]);
  return isSaved ? <ActivityPage /> : <ComparisonPage />;
};

export const ActivityRoute: React.FC = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const tab = params.get('tab');
  if (tab === 'schedule' || tab === 'application') return <ActivityPage />;
  params.set('tab', 'saved');
  return <Navigate to={`/comparison?${params.toString()}${location.hash}`} replace />;
};
